export interface AwsConfig {
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  graphqlUrl: string;
  realtimeUrl: string;
  /**
   * Origin serving user-uploaded images. Deliberately a different host from
   * the app, and the only origin `<img src>` is allowed to reference.
   */
  uploadsUrl: string;
}

let current: AwsConfig | null = null;

/** Set by configure(); see richtext.setAllowedImageOrigin. */
let onConfigured: ((config: AwsConfig) => void) | null = null;

/**
 * Registered by richtext at module load. Keeps config free of a circular
 * import while still guaranteeing the image allowlist is bound exactly when
 * the app is configured — one fewer thing an app can forget to call.
 */
export function onConfigure(fn: (config: AwsConfig) => void): void {
  onConfigured = fn;
}

export function configure(config: AwsConfig): void {
  current = config;
  onConfigured?.(config);
}

export function getConfig(): AwsConfig {
  if (!current) {
    throw new Error(
      'og-aim is not configured. Call configure(awsConfig) at app startup. ' +
        'If aws-config.generated.ts is missing, deploy the backend first: pnpm infra:deploy'
    );
  }
  return current;
}
